const createTheme = (theme: Record<string, unknown> = {}) => theme;

export default createTheme;
